import { AutenticacionService,ModulosARK, TipoPermiso } from './../../services/autenticacion.service';
import { ReporteResumenObraService } from './../../services/reporte-resumen-obra.service';
import { SecurityModalComponent } from './../partials/security-modal/security-modal.component';
import { ReportesService } from './../../services/reportes.service';
import { DomSanitizer } from '@angular/platform-browser';
import { HelpersService } from './../../services/tools/helpers.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ReporteResumenDeObraGruposModalComponent } from '../reporte-resumen-de-obra/reporte-resumen-de-obra-grupos-modal/reporte-resumen-de-obra-grupos-modal.component';
import { ReporteResumenDeObraRetornosModalComponent } from '../reporte-resumen-de-obra/reporte-resumen-de-obra-retornos-modal/reporte-resumen-de-obra-retornos-modal.component';


@Component({
  selector: 'app-reporte-saldos',
  templateUrl: './reporte-saldos.component.html',
  styleUrls: ['./reporte-saldos.component.scss']
})
export class ReporteSaldosComponent implements OnInit {
  @ViewChild(SecurityModalComponent) securityModal: SecurityModalComponent;
  @ViewChild(ReporteResumenDeObraGruposModalComponent) gruposModal: ReporteResumenDeObraGruposModalComponent;
  @ViewChild(ReporteResumenDeObraRetornosModalComponent) retornosDetalleModal: ReporteResumenDeObraRetornosModalComponent;
  public reportes_lista: any[] = [];
  public reporte_actual: any;
  public fecha_actual: any;
  public fecha_generado: any;
  public fecha_filter: any;
  public fecha_selected: any;
  public fecha_inicial_filter: any;
  public fecha_inicial_selected: any;
  public fecha_final_filter: any;
  public fecha_final_selected: any;
  public obra_filter: any;
  public obra_options: any[];
  public obra_selected: any = {};
  public totales_selected: any = {};
  public totales2_selected: any = {};
  public movimientos_ingreso: any[] = [];
  public movimientos_egreso: any[] = [];
  public movimientos_tipos_egreso: any[] = [];
  public movimientos_tipos_ingreso: any[] = [];
  public movimientos_grupos: any[] = [];
  public movimientos_proveedores: any[] = [];
  public movimientos_honorario: any[] = [];
  public movimientos_retorno: any[] = [];
  public traspasos: any[] = [];
  public traspasos2: any[] = [];
  public cuentas: any[] = [];
  public cuentas2: any[] = [];
  public retornos_detalle:any[] = [];
  public securityActived: any = false;
  public loading_report: any = true;
  public loading_report1: any = true;
  public loading_report2: any = true;
  public show_report: any = false;
  public not_report: any = false;
  public printing: boolean = false;
  public report_request: any;
  public report2_request: any;
  constructor(  private reportesService: ReportesService,
                private reporteResumenObraService: ReporteResumenObraService,
                private router: Router, 
                private activedRoute: ActivatedRoute, 
                private helperService: HelpersService, 
                private sanitizer: DomSanitizer,
                private authService: AutenticacionService) { }

  ngOnInit() {
    this.start();
  }

  start() {
    let reportes_lista = this.reportesService.getListaReportes();
    for (let i = 0; i < reportes_lista.length; i++) {  
      if(reportes_lista[i]["id"] == 1 && this.authService.tienenPermisos(ModulosARK.ReportePorInversionista, TipoPermiso.Lectura)){
        this.reportes_lista.push(reportes_lista[i]);
      }
      if(reportes_lista[i]["id"] == 2 && this.authService.tienenPermisos(ModulosARK.ReporteResumenDeObra, TipoPermiso.Lectura)){
        this.reportes_lista.push(reportes_lista[i]);
      }
      if(reportes_lista[i]["id"] == 3 && this.authService.tienenPermisos(ModulosARK.ReportePorObra, TipoPermiso.Lectura)){
        this.reportes_lista.push(reportes_lista[i]);
      }
      if(reportes_lista[i]["id"] == 4 && this.authService.tienenPermisos(ModulosARK.ReporteBalanceKr, TipoPermiso.Lectura)){
        this.reportes_lista.push(reportes_lista[i]);
      }
      if(reportes_lista[i]["id"] == 5 && this.authService.tienenPermisos(ModulosARK.ReportePuntoDeEquilibrio, TipoPermiso.Lectura)){
        this.reportes_lista.push(reportes_lista[i]);
      }
      if(reportes_lista[i]["id"] == 6 && this.authService.tienenPermisos(ModulosARK.ReporteResumenDeDiferencia, TipoPermiso.Lectura)){
        this.reportes_lista.push(reportes_lista[i]);
      }
      if(reportes_lista[i]["id"] == 7 && this.authService.tienenPermisos(ModulosARK.ReporteSaldos, TipoPermiso.Lectura)){
        this.reportes_lista.push(reportes_lista[i]);
      }
      if(reportes_lista[i]["id"] == 8 && this.authService.tienenPermisos(ModulosARK.ReporteDepositoGarantia, TipoPermiso.Lectura)){
        this.reportes_lista.push(reportes_lista[i]);
      }
      if(reportes_lista[i]["id"] == 9 && this.authService.tienenPermisos(ModulosARK.ReporteCobranza, TipoPermiso.Lectura)){
        this.reportes_lista.push(reportes_lista[i]);
      }
    }
    //determinar si es resumen de dif o no
    if(this.router.url=== '/catalogo-reportes/reporte-resumen-diferencia' ){
      this.reporte_actual = this.reportes_lista.find((reporte) => {
        return reporte.id == 6 // reporte resumen de diferencias
      });
    }else if(this.router.url=== '/catalogo-reportes/reporte-resumen-obra'){
      this.reporte_actual = this.reportes_lista.find((reporte) => {
        return reporte.id == 2 // reporte resumen de obra
      });
    }else if(this.router.url=== '/catalogo-reportes/reporte-saldos'){
      this.reporte_actual = this.reportes_lista.find((reporte) => {
        return reporte.id == 7 // reporte resumen de obra KR
      });
    }


    

    this.getFechaActual();
    this.getObras();
  }

  isResumenDeObra(){
    return false;
  }

  isResumenDeDiferencias(){
    return true;
  }


  changeReporte(reporte) {
    if (reporte.id && reporte.id != this.reporte_actual.id) {
      this.router.navigate([reporte.ruta]);
    }
  }

  getFechaActual() {
    this.reportesService.getFechaActual()
        .subscribe((response) => {
          const content = response.json().content;
          this.fecha_actual = content.fecha;
          this.fecha_filter = this.fecha_actual;
          this.fecha_final_filter = this.fecha_actual;
          this.fecha_inicial_filter = content.fechaSemanaInicio;
        }, (error) => {
          // se revisan errores 403 - 500
          this.helperService.httpGlobalError(error);

          if (error == 400) {
            console.log('getFechasActual - error 400 ' , error);
          }
        });
  }

  getObras() {
    this.reporteResumenObraService.getObras().subscribe(response => {
      const content = response.json().content;
      this.obra_options = content;
      if (this.obra_options.length > 0) {
        this.changeObraFilter(this.obra_options[0]);
      }
    }, error => {
      this.helperService.httpGlobalError(error, true);
    });
  }

  getReporte() {
    if (!this.obra_filter) {
      console.log('no traemos reporte por inversionista, pues no se ha seleccionado inversionista');
      return false;
    }

    this.loading_report = true;
    this.loading_report1 = true;
    this.loading_report2 = true;
    this.show_report = false;
    if (this.report_request) {
      this.report_request.unsubscribe();
    }
    if (this.report2_request) {
      this.report2_request.unsubscribe();
    }
    if(this.isResumenDeObra()){
      this.report_request = this.reporteResumenObraService.getReporteResumenDeObra(this.obra_filter.idObras, this.fecha_filter)
      .subscribe(response => {
        const content_response = response.json().content;
        this.obra_selected = this.obra_filter;
        this.fecha_selected = content_response.fechas.fechaFinal;
        this.fecha_inicial_selected = content_response.fechas.fechaInicial;
        this.fecha_final_selected = content_response.fechas.fechaFinal;
        this.totales_selected = content_response.totales;
        this.movimientos_ingreso = content_response.tipos_movimiento.tipo_ingreso;
        this.movimientos_egreso = content_response.tipos_movimiento.tipo_egresos;
        this.movimientos_tipos_egreso = content_response.por_proveedores.proveedores_egreso;
        this.movimientos_tipos_ingreso = content_response.por_proveedores.proveedores_ingreso;
        this.movimientos_grupos = content_response.grupos_proveedores;
        this.movimientos_proveedores = content_response.proveedores;
        this.movimientos_honorario = content_response.honorarios;
        this.movimientos_retorno = content_response.retornos;
        this.traspasos = content_response.traspasos;
        this.cuentas = content_response.cuentas;
        this.retornos_detalle = content_response.retornos_detalle;
        console.log('content_response ', content_response);
        console.log('cuentas ', this.cuentas);
        console.log('movimientos_ingreso ', this.movimientos_ingreso);
        console.log('movimientos_egreso ', this.movimientos_egreso);
        this.loading_report1 = false;
        if(!(this.loading_report1 && this.loading_report2)){
            this.loading_report = false;
            this.show_report = true;
            this.not_report = false;
        }
       
        this.fecha_generado = content_response.fecha_generado;
      }, error => {
        // resuelve errores 403, 500 y sin conexión.
        this.helperService.httpGlobalError(error);
        this.loading_report = false;
        this.show_report = false;
        this.not_report = true;
      });
    }else if(this.isResumenDeDiferencias){
      this.report_request = this.reporteResumenObraService.getReporteResumenDeDiferencias(this.obra_filter.idObras, this.fecha_inicial_filter,this.fecha_final_filter)
      .subscribe(response => {
        const content_response = response.json().content;
        this.obra_selected = this.obra_filter;
        this.fecha_selected = content_response.fechas.fechaFinal;
        this.fecha_inicial_selected = content_response.fechas.fechaInicial;
        this.fecha_final_selected = content_response.fechas.fechaFinal;
        this.totales_selected = content_response.totales;
        this.movimientos_ingreso = content_response.tipos_movimiento.tipo_ingreso;
        this.movimientos_egreso = content_response.tipos_movimiento.tipo_egresos;
        this.movimientos_tipos_egreso = content_response.por_proveedores.proveedores_egreso;
        this.movimientos_tipos_ingreso = content_response.por_proveedores.proveedores_ingreso;
        this.movimientos_grupos = content_response.grupos_proveedores;
        this.movimientos_proveedores = content_response.proveedores;
        this.movimientos_honorario = content_response.honorarios;
        this.movimientos_retorno = content_response.retornos;
        this.traspasos = content_response.traspasos;
        this.cuentas = content_response.cuentas;
        this.retornos_detalle = content_response.retornos_detalle;
        console.log('content_response ', content_response);
        console.log('cuentas ', this.cuentas);
        console.log('movimientos_ingreso ', this.movimientos_ingreso);
        console.log('movimientos_egreso ', this.movimientos_egreso);
        this.loading_report2 = false;
        if(!(this.loading_report1 && this.loading_report2)){
            this.loading_report = false;
            this.show_report = true;
            this.not_report = false;
        }
        this.fecha_generado = content_response.fecha_generado;
      }, error => {
        // resuelve errores 403, 500 y sin conexión.
        this.helperService.httpGlobalError(error);
        this.loading_report = false;
        this.show_report = false;
        this.not_report = true;
      });

      this.report2_request = this.reporteResumenObraService.getReporteResumenDeObra(this.obra_filter.idObras, this.fecha_inicial_filter)
      .subscribe(response => {
        const content_response = response.json().content;
        this.totales2_selected = content_response.totales;
        this.cuentas2 = content_response.cuentas;
        this.traspasos2 = content_response.traspasos;

      }, error => {
        // resuelve errores 403, 500 y sin conexión.
        this.helperService.httpGlobalError(error);

      });

    }

    
  }

  getGruposProveedoresNombres(grupos) {
    let gruposList = '--';
    if (grupos) {
      gruposList = '';
      grupos.forEach((element, key) => {
          if (key > 0) {
            gruposList += ', ';
          }
          gruposList += element.nombre;
      });
    }

    return gruposList;
  }

  changeObraFilter(obra) {
    this.obra_filter = obra;
    this.getReporte();
  }

  changeFechaFilter(fecha) {
    this.fecha_filter = fecha;
    this.getReporte();
  }

  changeFilterFechaInicial(fecha) {
    this.fecha_inicial_filter = fecha;
    setTimeout(() => {
      this.getReporte();
    }, 200);
  }

  changeFilterFechaFinal(fecha) {
    this.fecha_final_filter = fecha;
    setTimeout(() => {
      this.getReporte();
    }, 200);
  }
  return() {
    this.router.navigate(['/catalogo-reportes']);
  }

  showModalGrupos(movimiento, modalTitle) {

    //Modal particular para los retornos
    if(movimiento.idConceptos==820){
      this.retornosDetalleModal.open({
        modalTitle: modalTitle,
        grupos: [{
          nombre: "Retornos",
          movimientos: this.retornos_detalle
        }],
        obra: this.obra_selected
      });
      return false;
    }

    let gruposArray = [];
    if (!movimiento.isGroup) {
      this.movimientos_proveedores.forEach(mov_grupo => {
        mov_grupo.forEach(movimiento_grupo => {
          if(movimiento_grupo !== undefined)
          {
            console.log("Revisando que trae el movimiento individual -----------> ",movimiento_grupo);
            if (movimiento_grupo.folio === movimiento.folio && movimiento_grupo.idConceptos === movimiento.idConceptos) {
              gruposArray.push(movimiento_grupo);
            }
          }  
        });
        
      });
    }
    
    console.log("El movimientos is grup -------> ",movimiento);
    this.movimientos_grupos.forEach(mov_grupo => {
      mov_grupo.forEach(movimiento_grupo => {
        if(movimiento_grupo !== undefined)
        {
          console.log("Revisando que trae el movimiento grupo -----------> ",movimiento_grupo[movimiento.isGroup]);
          console.log("Revisando que trae el movimiento -----------> ",movimiento_grupo);
          if (movimiento_grupo[movimiento.isGroup] && movimiento_grupo.folio === movimiento.folio && movimiento_grupo.idConceptos === movimiento.idConceptos) {
            gruposArray.push(movimiento_grupo);
          }
        }  
      });
      
    });
    if (gruposArray.length <= 0) {
      return false;
    }
    this.gruposModal.open({
      modalTitle: modalTitle,
      grupos: gruposArray,
      obra: this.obra_selected
    });
  }

  print() {
    this.printing = true;
    setTimeout(() => {
      window.print();
    }, 1200);
    window.onafterprint = window.onbeforeprint= () => {
      console.log('end to print');
      this.printing = false;
    };
  }

  // SEGURITY MODULE
  securityModule() {
    if (!this.securityActived) {
      this.securityModal.open();
    } else {
      this.authService.closeKey()
        .subscribe((response) => {
          const respuesta = response.json();
          this.getReporte();
          if (respuesta.success) {
            this.securityActived = false;
            this.securityModal.push({
            'passwordActivated': false
          });
          }
        });
    }
  }

  canSecurity() {
    return this.reportesService.canSecurity();
  }

  checkSecurityKey(password) {
    this.securityModal.loading = true;
    this.reportesService.activeSecurityModule(password)
      .subscribe((response) => {
        const respuesta = response.json();
        this.securityModal.loading = false;
        if(respuesta.success === true) {
          this.getReporte();
          this.securityModal.push({
            'passwordActivated': true
          });
          this.securityModal.close();
          this.securityActived = true;
        }
      }, (error) => {
        this.securityModal.loading = false;
        this.helperService.httpGlobalError(error, false);
        this.securityModal.lock();
        this.securityActived = false;
        this.securityModal.push({
          'passwordActivated': false
        });
      })
  }

  sumaIngresos(listaMovimientos){
    var ingresos_total=0;
    for(var i=0;i<listaMovimientos.length;i++){
      var movimiento = listaMovimientos[i];
      ingresos_total += parseFloat(movimiento.ingreso);
    }
    return ingresos_total;
  }

  sumaEgresos(listaMovimientos){
    var egresos_total=0;
    for(var i=0;i<listaMovimientos.length;i++){
      var movimiento = listaMovimientos[i];
      egresos_total += parseFloat(movimiento.egreso);
    }
    return egresos_total;
  }

  sumaIngresosTraspasos(traspasos){
    var ingresos_total=0;
    for(var i=0;i<traspasos.length;i++){
      var traspaso = traspasos[i];
      if(!traspaso.ingreso){
        traspaso.ingreso=0.0;
      }
      ingresos_total += parseFloat(traspaso.ingreso);
    }
    return ingresos_total;
  }

  sumaEgresosTraspasos(traspasos){
    var egresos_total=0;
    for(var i=0;i<traspasos.length;i++){
      var traspaso = traspasos[i];
      if(!traspaso.egreso){
        traspaso.egreso=0.0;
      }
      egresos_total += parseFloat(traspaso.egreso);
    }
    return egresos_total;
  }

  sumaSaldosIngresos(cuentas){
    var ingresos_total=0;
    for(var i=0;i<cuentas.length;i++){
      var cuenta = cuentas[i];
      ingresos_total += parseFloat(cuenta.ingreso);
    }
    return ingresos_total;
  }

  sumaSaldosEgresos(cuentas){
    var egresos_total=0;
    for(var i=0;i<cuentas.length;i++){
      var cuenta = cuentas[i];
      egresos_total += parseFloat(cuenta.egreso);
    }
    return egresos_total;
  }

  sumaSaldosDiferencias(cuentas){
    var diferencia_total=0;
    for(var i=0;i<cuentas.length;i++){
      var cuenta = cuentas[i];
      diferencia_total += parseFloat(cuenta.diferencia);
    }
    return diferencia_total;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/reporte-saldos/reporte-saldos.component.ts